import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/i18n";

export default function Faq() {
  const { t } = useLang();
  const items = t("faq.items");

  return (
    <section id="faq" className="py-24 md:py-32" data-testid="faq-section">
      <div className="max-w-[900px] mx-auto px-6 md:px-12">
        <motion.p initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}
          className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-walnut flex items-center gap-3">
          <span className="inline-block w-10 h-px bg-terracotta" />
          {t("faq.eyebrow")}
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.1 }}
          className="mt-5 font-serif font-medium text-4xl md:text-5xl leading-[1.05] tracking-tight text-main">
          {t("faq.title")}
        </motion.h2>

        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.2 }} className="mt-12">
          <Accordion type="single" collapsible className="space-y-3">
            {items.map((item, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="bg-cream-light border border-warm-grey/40 rounded-2xl px-6 overflow-hidden" data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="font-serif text-lg md:text-xl text-main hover:text-terracotta hover:no-underline py-5 text-left">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm md:text-base text-brown/80 font-light leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
